import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function MicIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M12 6.8V8c0 2.32-1.79 4.2-4 4.2M4 6.8V8c0 2.32 1.79 4.2 4 4.2m0 0V14m-2.286 0h4.572M8 9.8c-.947 0-1.714-.806-1.714-1.8V3.8C6.286 2.806 7.053 2 8 2s1.714.806 1.714 1.8V8c0 .994-.767 1.8-1.714 1.8" /></svg>
  );
}

export default MicIcon;
